export const meta: BlockMeta = {
  title: "Sponsors",
  tags: ["subpage"],
}

import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/sponsors", (props) => {
  return (
    <div className={cn("mt-5 w-full", !env.admin && "grid grid-cols-2 md:grid-cols-4 gap-4")}>
      <InnerBlocks
        allowedBlocks={["content/sponsors-item"]}
        orientation="horizontal"
        defaultBlocks={[["content/sponsors-item", {}]]}
        adminClassName="grid grid-cols-2 md:grid-cols-4 gap-4 w-full"
      />
    </div>
  )
})
